import React from "react";
import Header from "./Header.js";
import Checkout from "./Checkout.js";

function CheckoutPage() {
  return (
    <div className="checkout_page">
      <Header />
      <Checkout />
    </div>
  );
}

export default CheckoutPage;
